<template>
  <div
    class="modal fade"
    :id="dialogId"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ confirmationTitle }}</b>
          </h4>
        </div>
        <div class="modal-body table-responsive" v-if="!htmlText">
          <slot></slot>
        </div>
        <div class="modal-body table-responsive" v-else v-html="htmlText"></div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised"
            data-dismiss="modal"
            @click="onNoConfirmation()"
            :disabled="noButtonDisable"
          >
            {{ noButtonText }}
          </button>
          <button
            type="button"
            class="btn btn-raised"
            :class="[this.colorRed ? 'btn-danger' : 'dialog-btn-primary']"
            @click="onYesConfirmation()"
            :disabled="yesButtonDisable"
          >
            {{ yesButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationDialog",
  props: {
    dialogId: {
      type: String,
      default: "confirmationDialog",
    },
    confirmationTitle: {
      type: String,
      default: "",
    },
    yesButtonText: {
      type: String,
      default: "Yes",
    },
    yesButtonDisable: {
      type: Boolean,
      default: false,
    },
    noButtonText: {
      type: String,
      default: "No",
    },
    noButtonDisable: {
      type: Boolean,
      default: false,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    colorRed: {
      type: Boolean,
      default: false,
    },
    htmlText: {
      type: String,
      default: "",
    },
  },
  mounted() {
    $("#" + this.dialogId).on("hide.bs.modal", (e) =>
      this.$emit("closeDialog")
    );
    $("#" + this.dialogId).on("hidden.bs.modal", (e) =>
      this.$emit("dialogClosed")
    );
  },
  watch: {
    showDialog() {
      this.showDialog
        ? this.openConfirmationDialog()
        : this.closeConfirmationDialog();
    },
  },
  methods: {
    openConfirmationDialog() {
      this.$nextTick(() => {
        $("#" + this.dialogId).modal("show");
      });
    },
    closeConfirmationDialog() {
      $("#" + this.dialogId).modal("hide");
    },
    onYesConfirmation() {
      this.$emit("onYesConfirmation");
    },
    onNoConfirmation() {
      this.$emit("onNoConfirmation");
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// ConfirmationDialog.vue?9796e7f6